import { render, staticRenderFns } from "./VoucherDetails.vue?vue&type=template&id=a889a402&scoped=true&"
import script from "./VoucherDetails.vue?vue&type=script&lang=js&"
export * from "./VoucherDetails.vue?vue&type=script&lang=js&"
import style0 from "./VoucherDetails.vue?vue&type=style&index=0&id=a889a402&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a889a402",
  null
  
)

export default component.exports